/**
 * Copyright (c) Riskaware 2021
 */

// Attribution detailed in https://docs.mapbox.com/help/getting-started/attribution
export const MAPBOX_LOGO_WHITE = '/images/logos/mapbox-logo-white.png';
export const MAPBOX_LOGO_BLACK = '/images/logos/mapbox-logo-black.png';
export const MAPBOX_ATTRIBUTION = '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> ' +
    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> ' +
    '<strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong> ' +
    '&copy; <a href="https://www.maxar.com/">Maxar</a>';

// Based on https://osdatahub.os.uk/brandLogo/copyrightOverview and copyright text from their
// assets (which differs a bit from website - so conflicted a bit) https://github.com/OrdnanceSurvey/os-api-branding
export const OS_MAPS_LOGO_URL = '/images/logos/os-logo-maps.png';
export const OS_MAPS_ATTRIBUTION = 'Contains OS data &copy; Crown copyright and database rights 2022';

// Based on https://www.openstreetmap.org/copyright
export const OPEN_STREET_MAP_ATTRIBUTION = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';

// Based on https://opentopomap.org/about
export const OPEN_TOPO_MAP_ATTRIBUTION = 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)';

// Based on https://carto.com/developers/carto-js/reference/
export const CARTO_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/about-carto/">CARTO</a>';
